import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _possible_constructor_return from "@swc/helpers/src/_possible_constructor_return.mjs";
import _wrap_native_super from "@swc/helpers/src/_wrap_native_super.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { removeUnTrackingData } from "@common/http/axios/axiosUtil";
export var AbstractError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(AbstractError, Error1);
    var _super = _create_super(AbstractError);
    function AbstractError(params) {
        var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "エラーが発生しました";
        _class_call_check(this, AbstractError);
        var _this;
        var defaultDisplayMessage = "問題が発生しました。ページを再読み込みしてください。\n問題が解消されない場合は誠に恐れ入りますが、しばらくお時間をおいてからご利用ください。";
        if ("config" in params) {
            var ref;
            _this = _super.call(this, errorMessage !== null && errorMessage !== void 0 ? errorMessage : params.message);
            var error = params;
            _this.name = _this.constructor.name;
            _this.displayMessage = defaultDisplayMessage;
            var ref1;
            _this.statusCode = (ref1 = (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : undefined;
            _this.data = {
                error: removeUnTrackingData(error)
            };
        } else {
            var displayMessage = params.displayMessage, statusCode = params.statusCode, data = params.data, stack = params.stack;
            _this = _super.call(this, errorMessage);
            _this.name = _this.constructor.name;
            _this.displayMessage = displayMessage !== null && displayMessage !== void 0 ? displayMessage : defaultDisplayMessage;
            _this.statusCode = statusCode;
            _this.data = data;
            _this.stack = stack;
        }
        if (_this.message == null) {
            _this.message = "エラーメッセージが設定されていません";
        }
        return _possible_constructor_return(_this);
    }
    var _proto = AbstractError.prototype;
    _proto.toString = function toString() {
        var ref;
        return JSON.stringify({
            name: this.name,
            message: this.message,
            // data は循環参照になっている場合があるようで `JSON.stringify()` できない
            // (`TypeError: Converting circular structure to JSON` が発生する)
            stack: (ref = this.stack) === null || ref === void 0 ? void 0 : ref.toString()
        });
    };
    return AbstractError;
}(_wrap_native_super(Error));
